/**
 * @flow
 * @relayHash 9a000f507cfc2d7a8096a222463cdded
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Builder_organization$ref = any;
type Modal_proposal$ref = any;
export type ProposalEditorQueryVariables = {|
  orgDatabaseId: string,
  proposalDatabaseId: string,
|};
export type ProposalEditorQueryResponse = {|
  +organization: ?{|
    +databaseId: string,
    +proposal: ?{|
      +id: string,
      +$fragmentRefs: Modal_proposal$ref,
    |},
    +$fragmentRefs: Builder_organization$ref,
  |}
|};
export type ProposalEditorQuery = {|
  variables: ProposalEditorQueryVariables,
  response: ProposalEditorQueryResponse,
|};
*/


/*
query ProposalEditorQuery(
  $orgDatabaseId: String!
  $proposalDatabaseId: String!
) {
  organization(databaseId: $orgDatabaseId) {
    databaseId
    ...Builder_organization
    proposal(databaseId: $proposalDatabaseId) {
      id
      ...Modal_proposal
    }
    id
  }
}

fragment Accountabilities_circle on Circle {
  databaseId
}

fragment Accountabilities_organization on Organization {
  accountabilitiesLabel: termFor(name: "accountabilities")
  accountatibilityCheckingIsEnabled
  databaseId
  locale
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment Builder_organization on Organization {
  databaseId
  isAiEnabled
  ...ChangeList_organization
  ...TensionEditor_organization
}

fragment Builder_proposal on Proposal {
  databaseId
  translationError
  ...ProposalContextProviderFragment_proposal
  circle {
    databaseId
    id
  }
  tension {
    id
    body
    databaseId
    ...TensionEditor_tension
  }
  ...TensionEditor_proposal
  ...ChangeList_proposal
  ...EditorFooter_proposal
}

fragment ChangeList_organization on Organization {
  ...Role_organization
  ...LinkedRole_organization
  ...Policy_organization
}

fragment ChangeList_proposal on Proposal {
  id
  hasConflicts
  changes(first: 100) {
    edges {
      node {
        __typename
        id
        type
        ...LinkedRole_change
        ...Role_change
        ...Policy_change
        ...MoveItems_change
        ...ElectRoleFiller_change
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...Policy_proposal
  ...Role_proposal
}

fragment Delete_proposal on Proposal {
  id
  tension {
    id
    isAutogenerated
    databaseId
  }
}

fragment EditorFooter_proposal on Proposal {
  id
  status
  ...PartSelector_proposal
}

fragment Editor_organization on Organization {
  databaseId
  domainsLabel: termFor(name: "domains")
  purposeLabel: termFor(name: "purpose")
  showAccountabilities: featureEnabled(name: "accountabilities")
  showDomains: featureEnabled(name: "domains")
  showPurpose: featureEnabled(name: "purpose")
  roleTemplates(first: 100) {
    edges {
      node {
        id
      }
    }
  }
  ...RoleTemplateSelector_organization
  ...Accountabilities_organization
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment Editor_proposal on Proposal {
  circle {
    databaseId
    ...Accountabilities_circle
    id
  }
}

fragment ElectRoleFillerSelect_proposal on Proposal {
  databaseId
  availableElectedRoles: availableRoles(elected: true) {
    edges {
      currentlyHoldingElection
      node {
        databaseId
        localizedName
        id
      }
    }
  }
}

fragment ElectRoleFiller_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  id
  databaseId
  command
  type
  alerts {
    path
    message
    severity
  }
  ... on ElectRoleFillerChange {
    organization {
      autocompletePeople(first: 10000) {
        name
        databaseId
      }
      id
    }
    assignedUntil
    person {
      databaseId
      name
      id
    }
    role {
      databaseId
      localizedName
      id
    }
  }
}

fragment LinkedRole_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  id
  databaseId
  type
  ... on LinkedRoleChange {
    availableRoles(first: 100) {
      edges {
        node {
          databaseId
          localizedName
          circle {
            localizedName
            id
          }
          id
        }
      }
    }
    circle {
      databaseId
      localizedName
      ...Accountabilities_circle
      id
    }
    originalRole {
      databaseId
      localizedName
      purpose
      id
    }
    linkedRole {
      databaseId
      localizedName
      accountabilities(first: 100) {
        edges {
          node {
            databaseId
            description
            isProtected
            id
          }
        }
      }
      domains(first: 100) {
        edges {
          node {
            databaseId
            description
            isProtected
            id
          }
        }
      }
      originalRole {
        databaseId
        localizedName
        purpose
        circle {
          localizedName
          id
        }
        accountabilities(first: 100) {
          edges {
            node {
              databaseId
              description
              isProtected
              id
            }
          }
        }
        domains(first: 100) {
          edges {
            node {
              databaseId
              description
              isProtected
              id
            }
          }
        }
        id
      }
      id
    }
  }
  ...SummarySections_change
  command
  alerts {
    path
    message
    severity
  }
}

fragment LinkedRole_organization on Organization {
  databaseId
  domainsLabel: termFor(name: "domains")
  purposeLabel: termFor(name: "purpose")
  ...Accountabilities_organization
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment Modal_proposal on Proposal {
  databaseId
  status
  expectedResponseCount
  reviewStatus
  changes(first: 100) {
    edges {
      node {
        __typename
        databaseId
        id
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  tension {
    databaseId
    agendaLabel
    meetingType
    id
  }
  ...Builder_proposal
  ...Delete_proposal
  ...ProposeNowContainer_proposal
}

fragment MoveItems_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  id
  databaseId
  command
  type
  alerts {
    path
    message
    severity
  }
  ... on MoveItemsChange {
    role {
      databaseId
      circlePolicies {
        edges {
          node {
            databaseId
            displayName: title
            resourcePath
            id
          }
        }
      }
      circleRoles {
        edges {
          node {
            databaseId
            displayName: localizedName
            resourcePath
            id
          }
        }
      }
      id
    }
    childSupportedRole {
      databaseId
      localizedName
      circlePolicies {
        edges {
          node {
            databaseId
            displayName: title
            resourcePath
            id
          }
        }
      }
      circleRoles {
        edges {
          node {
            databaseId
            displayName: localizedName
            resourcePath
            id
          }
        }
      }
      id
    }
    roleHasBeenRemoved
    policiesToMoveUp {
      databaseId
      id
    }
    policiesToMoveDown {
      databaseId
      id
    }
    rolesToMoveUp {
      databaseId
      id
    }
    rolesToMoveDown {
      databaseId
      id
    }
  }
}

fragment PartSelector_proposal on Proposal {
  id
  tension {
    body
    id
  }
  availableSupportedRoles {
    edges {
      node {
        id
      }
    }
  }
  ...RoleSelect_proposal
  ...PolicySelect_proposal
  ...SupportedRoleSelect_proposal
  ...ElectRoleFillerSelect_proposal
}

fragment PolicySelect_proposal on Proposal {
  databaseId
  availablePolicies {
    edges {
      currentlyUpdating
      node {
        databaseId
        title
        domain {
          databaseId
          id
        }
        id
      }
    }
  }
}

fragment Policy_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  ... on PolicyChange {
    availableDomains(first: 100) {
      edges {
        node {
          databaseId
          description(format: PLAIN)
          id
        }
      }
    }
    policyHasBeenRemoved
    policy {
      databaseId
      title
      body
      domain {
        databaseId
        description
        id
      }
      id
    }
  }
  ...SummarySections_change
  command
  databaseId
  id
  type
  alerts {
    path
    message
    severity
  }
}

fragment Policy_organization on Organization {
  databaseId
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment Policy_proposal on Proposal {
  databaseId
  circle {
    databaseId
    id
  }
  tension {
    body
    id
  }
}

fragment ProposalContextProviderFragment_proposal on Proposal {
  id
  databaseId
  tension {
    id
    databaseId
    body
  }
  circle {
    id
    databaseId
    localizedName
  }
}

fragment ProposeNowContainer_proposal on Proposal {
  ...ProposeNow_proposal
}

fragment ProposeNow_proposal on Proposal {
  id
  status
  databaseId
  canBeAccepted
  hasChanges
  expectedResponseCount
  organization {
    asyncProposalsAreEnabled
    id
  }
  circle {
    isGovernanceEnabled
    id
  }
}

fragment RoleSelect_proposal on Proposal {
  databaseId
  viewerCanLinkRole
  organization {
    onRestrictedPlan
    isOnV5
    id
  }
  circle {
    databaseId
    id
  }
  availableRoles {
    edges {
      currentlyUpdating
      node {
        databaseId
        localizedName
        isLinked
        id
      }
    }
  }
}

fragment RoleTemplateSelector_organization on Organization {
  onRestrictedPlan
  roleTemplates(first: 100) {
    edges {
      node {
        databaseId
        name
        purpose
        domains
        accountabilities
        id
      }
    }
  }
}

fragment Role_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  ... on RoleChange {
    role {
      circlePolicies {
        edges {
          node {
            databaseId
            displayName: title
            id
          }
        }
      }
      circleRoles {
        edges {
          node {
            databaseId
            displayName: localizedName
            id
          }
        }
      }
      id
      databaseId
      name: localizedName
      localizedName
      rawPurpose: purpose(format: RAW)
      mdPurpose: purpose(format: MARKDOWN)
      isProtected
      supportingCircle {
        id
      }
      circle {
        supportedRole {
          databaseId
          id
        }
        id
      }
      domains(first: 100) {
        edges {
          node {
            databaseId
            rawDescription: description(format: RAW)
            markdownDescription: description(format: MARKDOWN)
            isProtected
            id
          }
        }
      }
      accountabilities(first: 100) {
        edges {
          node {
            databaseId
            rawDescription: description(format: RAW)
            markdownDescription: description(format: MARKDOWN)
            isProtected
            id
          }
        }
      }
    }
    circle {
      databaseId
      localizedName
      shortName
      supportedRole {
        databaseId
        id
      }
      policies(first: 100) {
        edges {
          node {
            databaseId
            displayName: title
            id
          }
        }
      }
      roles(first: 100) {
        edges {
          node {
            databaseId
            displayName: localizedName
            isProtected
            id
          }
        }
      }
      id
    }
    roleHasBeenRemoved
    organization {
      isWysiwygEnabled
      isOnV4
      id
    }
    rolesToMoveDown {
      databaseId
      id
    }
    rolesToMoveUp {
      databaseId
      id
    }
    policiesToMoveDown {
      databaseId
      id
    }
    policiesToMoveUp {
      databaseId
      id
    }
  }
  ...SummarySections_change
  command
  databaseId
  id
  type
  alerts {
    path
    message
    severity
  }
}

fragment Role_organization on Organization {
  ...Editor_organization
}

fragment Role_proposal on Proposal {
  ...Editor_proposal
}

fragment SelectRole_tension on Tension {
  availableRoles {
    edges {
      node {
        id
        nameWithCircleForCoreRoles: localizedName(with: CIRCLE_FOR_CORE_ROLES)
      }
    }
  }
  circle {
    supportedRole {
      id
      databaseId
      isExpanded
      nameWithCircleForCoreRoles: localizedName(with: CIRCLE_FOR_CORE_ROLES)
    }
    roles {
      edges {
        node {
          id
          nameWithCircleForCoreRoles: localizedName(with: CIRCLE_FOR_CORE_ROLES)
        }
      }
    }
    id
  }
}

fragment SummarySections_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  summary {
    title
    sections
  }
}

fragment SupportedRoleSelect_proposal on Proposal {
  databaseId
  availableSupportedRoles {
    edges {
      currentlyUpdating
      node {
        databaseId
        localizedName
        id
      }
    }
  }
}

fragment TensionBodyInput_circle on Circle {
  databaseId
}

fragment TensionBodyInput_organization on Organization {
  databaseId
  ...WYSIWYGTextareaWithFeatureFlag_organization
}

fragment TensionEditor_organization on Organization {
  databaseId
  ...TensionBodyInput_organization
}

fragment TensionEditor_proposal on Proposal {
  circle {
    databaseId
    ...TensionBodyInput_circle
    id
  }
}

fragment TensionEditor_tension on Tension {
  body
  databaseId
  id
  isAutogenerated
  impactedRole {
    id
  }
  ...SelectRole_tension
}

fragment WYSIWYGTextareaWithFeatureFlag_organization on Organization {
  databaseId
  isWysiwygEnabled
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgDatabaseId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposalDatabaseId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "orgDatabaseId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "proposalDatabaseId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "domains"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "purpose"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "accountabilities"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "purpose",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onRestrictedPlan",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWysiwygEnabled",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Circle",
  "kind": "LinkedField",
  "name": "circle",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  (v2/*: any*/),
  (v14/*: any*/),
  (v4/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProtected",
  "storageKey": null
},
v19 = [
  (v2/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v4/*: any*/)
],
v20 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "AccountabilityConnection",
  "kind": "LinkedField",
  "name": "accountabilities",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountabilityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Accountability",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "accountabilities(first:100)"
},
v21 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "DomainConnection",
  "kind": "LinkedField",
  "name": "domains",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DomainEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Domain",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "domains(first:100)"
},
v22 = {
  "alias": "displayName",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PolicyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Policy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v22/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v24 = {
  "alias": "displayName",
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "RAW"
  }
],
v26 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MARKDOWN"
  }
],
v27 = [
  (v4/*: any*/)
],
v28 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "supportedRole",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = [
  (v2/*: any*/),
  {
    "alias": "rawDescription",
    "args": (v25/*: any*/),
    "kind": "ScalarField",
    "name": "description",
    "storageKey": "description(format:\"RAW\")"
  },
  {
    "alias": "markdownDescription",
    "args": (v26/*: any*/),
    "kind": "ScalarField",
    "name": "description",
    "storageKey": "description(format:\"MARKDOWN\")"
  },
  (v18/*: any*/),
  (v4/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleHasBeenRemoved",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "rolesToMoveDown",
  "plural": true,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "rolesToMoveUp",
  "plural": true,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Policy",
  "kind": "LinkedField",
  "name": "policiesToMoveDown",
  "plural": true,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Policy",
  "kind": "LinkedField",
  "name": "policiesToMoveUp",
  "plural": true,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "PolicyConnection",
  "kind": "LinkedField",
  "name": "circlePolicies",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PolicyEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v22/*: any*/),
            (v37/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "RoleConnection",
  "kind": "LinkedField",
  "name": "circleRoles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v24/*: any*/),
            (v37/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": "nameWithCircleForCoreRoles",
  "args": [
    {
      "kind": "Literal",
      "name": "with",
      "value": "CIRCLE_FOR_CORE_ROLES"
    }
  ],
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": "localizedName(with:\"CIRCLE_FOR_CORE_ROLES\")"
},
v41 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RoleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Role",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v40/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentlyUpdating",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposalEditorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Modal_proposal"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Builder_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposalEditorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAiEnabled",
            "storageKey": null
          },
          {
            "alias": "domainsLabel",
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"domains\")"
          },
          {
            "alias": "purposeLabel",
            "args": (v6/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"purpose\")"
          },
          {
            "alias": "showAccountabilities",
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"accountabilities\")"
          },
          {
            "alias": "showDomains",
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"domains\")"
          },
          {
            "alias": "showPurpose",
            "args": (v6/*: any*/),
            "kind": "ScalarField",
            "name": "featureEnabled",
            "storageKey": "featureEnabled(name:\"purpose\")"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "RoleTemplateConnection",
            "kind": "LinkedField",
            "name": "roleTemplates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleTemplateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTemplate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "domains",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountabilities",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "roleTemplates(first:100)"
          },
          (v11/*: any*/),
          {
            "alias": "accountabilitiesLabel",
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "termFor",
            "storageKey": "termFor(name:\"accountabilities\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountatibilityCheckingIsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expectedResponseCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reviewStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "DescribeChangeableConnection",
                "kind": "LinkedField",
                "name": "changes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DescribeChangeableEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDescribeChangeable"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChangeSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sections",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "command",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Alert",
                            "kind": "LinkedField",
                            "name": "alerts",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "path",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "severity",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": (v8/*: any*/),
                                "concreteType": "RoleConnection",
                                "kind": "LinkedField",
                                "name": "availableRoles",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoleEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Role",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "availableRoles(first:100)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Circle",
                                "kind": "LinkedField",
                                "name": "circle",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "originalRole",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v14/*: any*/),
                                  (v10/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "linkedRole",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v14/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Role",
                                    "kind": "LinkedField",
                                    "name": "originalRole",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v14/*: any*/),
                                      (v10/*: any*/),
                                      (v15/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LinkedRoleChange",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PolicyConnection",
                                    "kind": "LinkedField",
                                    "name": "circlePolicies",
                                    "plural": false,
                                    "selections": (v23/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoleConnection",
                                    "kind": "LinkedField",
                                    "name": "circleRoles",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Role",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v24/*: any*/),
                                              (v4/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": "name",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "localizedName",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": "rawPurpose",
                                    "args": (v25/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "purpose",
                                    "storageKey": "purpose(format:\"RAW\")"
                                  },
                                  {
                                    "alias": "mdPurpose",
                                    "args": (v26/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "purpose",
                                    "storageKey": "purpose(format:\"MARKDOWN\")"
                                  },
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Circle",
                                    "kind": "LinkedField",
                                    "name": "supportingCircle",
                                    "plural": false,
                                    "selections": (v27/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Circle",
                                    "kind": "LinkedField",
                                    "name": "circle",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v8/*: any*/),
                                    "concreteType": "DomainConnection",
                                    "kind": "LinkedField",
                                    "name": "domains",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DomainEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Domain",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v30/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "domains(first:100)"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v8/*: any*/),
                                    "concreteType": "AccountabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "accountabilities",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AccountabilityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Accountability",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v30/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "accountabilities(first:100)"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Circle",
                                "kind": "LinkedField",
                                "name": "circle",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "shortName",
                                    "storageKey": null
                                  },
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v8/*: any*/),
                                    "concreteType": "PolicyConnection",
                                    "kind": "LinkedField",
                                    "name": "policies",
                                    "plural": false,
                                    "selections": (v23/*: any*/),
                                    "storageKey": "policies(first:100)"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v8/*: any*/),
                                    "concreteType": "RoleConnection",
                                    "kind": "LinkedField",
                                    "name": "roles",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Role",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v24/*: any*/),
                                              (v18/*: any*/),
                                              (v4/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "roles(first:100)"
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isOnV4",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/)
                            ],
                            "type": "RoleChange",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": (v8/*: any*/),
                                "concreteType": "DomainConnection",
                                "kind": "LinkedField",
                                "name": "availableDomains",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DomainEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Domain",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "format",
                                                "value": "PLAIN"
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "description",
                                            "storageKey": "description(format:\"PLAIN\")"
                                          },
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "availableDomains(first:100)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "policyHasBeenRemoved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Policy",
                                "kind": "LinkedField",
                                "name": "policy",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v13/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Domain",
                                    "kind": "LinkedField",
                                    "name": "domain",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v17/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PolicyChange",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "childSupportedRole",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v14/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v31/*: any*/),
                              (v35/*: any*/),
                              (v34/*: any*/),
                              (v33/*: any*/),
                              (v32/*: any*/)
                            ],
                            "type": "MoveItemsChange",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 10000
                                      }
                                    ],
                                    "concreteType": "AutocompletePerson",
                                    "kind": "LinkedField",
                                    "name": "autocompletePeople",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": "autocompletePeople(first:10000)"
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assignedUntil",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ElectRoleFillerChange",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "changes(first:100)"
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "ChangeList_changes",
                "kind": "LinkedHandle",
                "name": "changes"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tension",
                "kind": "LinkedField",
                "name": "tension",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "agendaLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingType",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAutogenerated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "impactedRole",
                    "plural": false,
                    "selections": (v27/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleConnection",
                    "kind": "LinkedField",
                    "name": "availableRoles",
                    "plural": false,
                    "selections": (v41/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Circle",
                    "kind": "LinkedField",
                    "name": "circle",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "supportedRole",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isExpanded",
                            "storageKey": null
                          },
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleConnection",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": false,
                        "selections": (v41/*: any*/),
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translationError",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Circle",
                "kind": "LinkedField",
                "name": "circle",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGovernanceEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasConflicts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailableSupportedRolesConnection",
                "kind": "LinkedField",
                "name": "availableSupportedRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableSupportedRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLinkRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOnV5",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "asyncProposalsAreEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailableRolesConnection",
                "kind": "LinkedField",
                "name": "availableRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLinked",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailablePoliciesConnection",
                "kind": "LinkedField",
                "name": "availablePolicies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailablePoliciesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Policy",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Domain",
                            "kind": "LinkedField",
                            "name": "domain",
                            "plural": false,
                            "selections": (v28/*: any*/),
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "availableElectedRoles",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "elected",
                    "value": true
                  }
                ],
                "concreteType": "AvailableRolesConnection",
                "kind": "LinkedField",
                "name": "availableRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentlyHoldingElection",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "availableRoles(elected:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canBeAccepted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasChanges",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9a000f507cfc2d7a8096a222463cdded",
    "metadata": {},
    "name": "ProposalEditorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12b4df121abe350f94b7c4a90ef43619';

module.exports = node;
